import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { VehiclePhotosType } from '../../../../core/types/interface'
import { api } from '../../../../services/api'
import { queriesKeys } from '../../queriesKeys'

export const useGetVehiclePhotos = (
  vehicleId: number
): UseQueryResult<VehiclePhotosType[], Error> =>
  useQuery({
    enabled: !!vehicleId,
    queryFn: () => api.vehicles_photos.getPhotosByVehicleId(vehicleId),
    queryKey: queriesKeys.vehicle_photos.getVehiclePhotos(vehicleId),
  })
